/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SplatRouteImport } from './routes/$'
import { Route as AuthRouteRouteImport } from './routes/_auth/route'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as PortalRouteRouteImport } from './routes/_portal/route'
import { Route as AuthFinishSignupRouteImport } from './routes/_auth/finish-signup'
import { Route as AuthOnboardingRouteRouteImport } from './routes/_auth/onboarding/route'
import { Route as AuthSigninRouteImport } from './routes/_auth/signin'
import { Route as AuthenticatedContainedRouteRouteImport } from './routes/_authenticated/_contained/route'
import { Route as AuthenticatedKanbanRouteImport } from './routes/_authenticated/kanban'
import { Route as AuthOnboardingAboutYouRouteImport } from './routes/_auth/onboarding/about-you'
import { Route as AuthOnboardingEmailRouteImport } from './routes/_auth/onboarding/email'
import { Route as AuthOnboardingInvoicesRouteImport } from './routes/_auth/onboarding/invoices'
import { Route as AuthOnboardingOrganizationRouteImport } from './routes/_auth/onboarding/organization'
import { Route as AuthSignupSplatRouteImport } from './routes/_auth/signup.$'
import { Route as AuthenticatedContainedAdminRouteRouteImport } from './routes/_authenticated/_contained/admin/route'
import { Route as AuthenticatedContainedDashboardRouteImport } from './routes/_authenticated/_contained/dashboard'
import { Route as AuthenticatedContainedHomeRouteImport } from './routes/_authenticated/_contained/home'
import { Route as AuthenticatedContainedSettingsRouteImport } from './routes/_authenticated/_contained/settings'
import { Route as PortalMyInvoicesIndexRouteImport } from './routes/_portal/my-invoices.index'
import { Route as PortalMyInvoicesInvoiceIdRouteImport } from './routes/_portal/my-invoices.$invoiceId'
import { Route as AuthenticatedContainedAdminIndexRouteImport } from './routes/_authenticated/_contained/admin/index'
import { Route as AuthenticatedContainedAdminOrganizationsRouteImport } from './routes/_authenticated/_contained/admin/organizations'
import { Route as AuthenticatedContainedAdminSettingsRouteImport } from './routes/_authenticated/_contained/admin/settings'
import { Route as AuthenticatedContainedAdminWorkflowsRouteImport } from './routes/_authenticated/_contained/admin/workflows'
import { Route as AuthenticatedContainedCustomersIndexRouteImport } from './routes/_authenticated/_contained/customers.index'
import { Route as AuthenticatedContainedCustomersCustomerIdRouteImport } from './routes/_authenticated/_contained/customers.$customerId'
import { Route as AuthenticatedContainedEventsIndexRouteImport } from './routes/_authenticated/_contained/events.index'
import { Route as AuthenticatedContainedEventsEventIdRouteImport } from './routes/_authenticated/_contained/events.$eventId'
import { Route as AuthenticatedContainedInvoicesIndexRouteImport } from './routes/_authenticated/_contained/invoices.index'
import { Route as AuthenticatedContainedInvoicesInvoiceIdRouteImport } from './routes/_authenticated/_contained/invoices.$invoiceId'
import { Route as AuthenticatedContainedReportsIndexRouteImport } from './routes/_authenticated/_contained/reports.index'
import { Route as AuthenticatedContainedReportsReportIdRouteImport } from './routes/_authenticated/_contained/reports.$reportId'
import { Route as AuthenticatedContainedWorkflowsIndexRouteImport } from './routes/_authenticated/_contained/workflows.index'
import { Route as AuthenticatedContainedWorkflowsWorkflowIdRouteImport } from './routes/_authenticated/_contained/workflows.$workflowId'
import { Route as PortalMyInvoicesPpInstallmentIdRouteImport } from './routes/_portal/my-invoices.pp.$installmentId'
import { Route as AuthenticatedContainedCustomersCustomerIdIndexRouteImport } from './routes/_authenticated/_contained/customers.$customerId.index'
import { Route as AuthenticatedContainedCustomersCustomerIdComposeRouteImport } from './routes/_authenticated/_contained/customers.$customerId.compose'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const SplatRoute = SplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRouteRoute = AuthRouteRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const PortalRouteRoute = PortalRouteRouteImport.update({
  id: '/_portal',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthFinishSignupRoute = AuthFinishSignupRouteImport.update({
  id: '/finish-signup',
  path: '/finish-signup',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthOnboardingRouteRoute = AuthOnboardingRouteRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthSigninRoute = AuthSigninRouteImport.update({
  id: '/signin',
  path: '/signin',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthenticatedContainedRouteRoute =
  AuthenticatedContainedRouteRouteImport.update({
    id: '/_contained',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedKanbanRoute = AuthenticatedKanbanRouteImport.update({
  id: '/kanban',
  path: '/kanban',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthOnboardingAboutYouRoute = AuthOnboardingAboutYouRouteImport.update({
  id: '/about-you',
  path: '/about-you',
  getParentRoute: () => AuthOnboardingRouteRoute,
} as any)
const AuthOnboardingEmailRoute = AuthOnboardingEmailRouteImport.update({
  id: '/email',
  path: '/email',
  getParentRoute: () => AuthOnboardingRouteRoute,
} as any)
const AuthOnboardingInvoicesRoute = AuthOnboardingInvoicesRouteImport.update({
  id: '/invoices',
  path: '/invoices',
  getParentRoute: () => AuthOnboardingRouteRoute,
} as any)
const AuthOnboardingOrganizationRoute =
  AuthOnboardingOrganizationRouteImport.update({
    id: '/organization',
    path: '/organization',
    getParentRoute: () => AuthOnboardingRouteRoute,
  } as any)
const AuthSignupSplatRoute = AuthSignupSplatRouteImport.update({
  id: '/signup/$',
  path: '/signup/$',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthenticatedContainedAdminRouteRoute =
  AuthenticatedContainedAdminRouteRouteImport.update({
    id: '/admin',
    path: '/admin',
    getParentRoute: () => AuthenticatedContainedRouteRoute,
  } as any)
const AuthenticatedContainedDashboardRoute =
  AuthenticatedContainedDashboardRouteImport.update({
    id: '/dashboard',
    path: '/dashboard',
    getParentRoute: () => AuthenticatedContainedRouteRoute,
  } as any)
const AuthenticatedContainedHomeRoute =
  AuthenticatedContainedHomeRouteImport.update({
    id: '/home',
    path: '/home',
    getParentRoute: () => AuthenticatedContainedRouteRoute,
  } as any)
const AuthenticatedContainedSettingsRoute =
  AuthenticatedContainedSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AuthenticatedContainedRouteRoute,
  } as any)
const PortalMyInvoicesIndexRoute = PortalMyInvoicesIndexRouteImport.update({
  id: '/my-invoices/',
  path: '/my-invoices/',
  getParentRoute: () => PortalRouteRoute,
} as any)
const PortalMyInvoicesInvoiceIdRoute =
  PortalMyInvoicesInvoiceIdRouteImport.update({
    id: '/my-invoices/$invoiceId',
    path: '/my-invoices/$invoiceId',
    getParentRoute: () => PortalRouteRoute,
  } as any)
const AuthenticatedContainedAdminIndexRoute =
  AuthenticatedContainedAdminIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedContainedAdminRouteRoute,
  } as any)
const AuthenticatedContainedAdminOrganizationsRoute =
  AuthenticatedContainedAdminOrganizationsRouteImport.update({
    id: '/organizations',
    path: '/organizations',
    getParentRoute: () => AuthenticatedContainedAdminRouteRoute,
  } as any)
const AuthenticatedContainedAdminSettingsRoute =
  AuthenticatedContainedAdminSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AuthenticatedContainedAdminRouteRoute,
  } as any)
const AuthenticatedContainedAdminWorkflowsRoute =
  AuthenticatedContainedAdminWorkflowsRouteImport.update({
    id: '/workflows',
    path: '/workflows',
    getParentRoute: () => AuthenticatedContainedAdminRouteRoute,
  } as any)
const AuthenticatedContainedCustomersIndexRoute =
  AuthenticatedContainedCustomersIndexRouteImport.update({
    id: '/customers/',
    path: '/customers/',
    getParentRoute: () => AuthenticatedContainedRouteRoute,
  } as any)
const AuthenticatedContainedCustomersCustomerIdRoute =
  AuthenticatedContainedCustomersCustomerIdRouteImport.update({
    id: '/customers/$customerId',
    path: '/customers/$customerId',
    getParentRoute: () => AuthenticatedContainedRouteRoute,
  } as any)
const AuthenticatedContainedEventsIndexRoute =
  AuthenticatedContainedEventsIndexRouteImport.update({
    id: '/events/',
    path: '/events/',
    getParentRoute: () => AuthenticatedContainedRouteRoute,
  } as any)
const AuthenticatedContainedEventsEventIdRoute =
  AuthenticatedContainedEventsEventIdRouteImport.update({
    id: '/events/$eventId',
    path: '/events/$eventId',
    getParentRoute: () => AuthenticatedContainedRouteRoute,
  } as any)
const AuthenticatedContainedInvoicesIndexRoute =
  AuthenticatedContainedInvoicesIndexRouteImport.update({
    id: '/invoices/',
    path: '/invoices/',
    getParentRoute: () => AuthenticatedContainedRouteRoute,
  } as any)
const AuthenticatedContainedInvoicesInvoiceIdRoute =
  AuthenticatedContainedInvoicesInvoiceIdRouteImport.update({
    id: '/invoices/$invoiceId',
    path: '/invoices/$invoiceId',
    getParentRoute: () => AuthenticatedContainedRouteRoute,
  } as any)
const AuthenticatedContainedReportsIndexRoute =
  AuthenticatedContainedReportsIndexRouteImport.update({
    id: '/reports/',
    path: '/reports/',
    getParentRoute: () => AuthenticatedContainedRouteRoute,
  } as any)
const AuthenticatedContainedReportsReportIdRoute =
  AuthenticatedContainedReportsReportIdRouteImport.update({
    id: '/reports/$reportId',
    path: '/reports/$reportId',
    getParentRoute: () => AuthenticatedContainedRouteRoute,
  } as any)
const AuthenticatedContainedWorkflowsIndexRoute =
  AuthenticatedContainedWorkflowsIndexRouteImport.update({
    id: '/workflows/',
    path: '/workflows/',
    getParentRoute: () => AuthenticatedContainedRouteRoute,
  } as any)
const AuthenticatedContainedWorkflowsWorkflowIdRoute =
  AuthenticatedContainedWorkflowsWorkflowIdRouteImport.update({
    id: '/workflows/$workflowId',
    path: '/workflows/$workflowId',
    getParentRoute: () => AuthenticatedContainedRouteRoute,
  } as any)
const PortalMyInvoicesPpInstallmentIdRoute =
  PortalMyInvoicesPpInstallmentIdRouteImport.update({
    id: '/my-invoices/pp/$installmentId',
    path: '/my-invoices/pp/$installmentId',
    getParentRoute: () => PortalRouteRoute,
  } as any)
const AuthenticatedContainedCustomersCustomerIdIndexRoute =
  AuthenticatedContainedCustomersCustomerIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedContainedCustomersCustomerIdRoute,
  } as any)
const AuthenticatedContainedCustomersCustomerIdComposeRoute =
  AuthenticatedContainedCustomersCustomerIdComposeRouteImport.update({
    id: '/compose',
    path: '/compose',
    getParentRoute: () => AuthenticatedContainedCustomersCustomerIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/$': typeof SplatRoute
  '/onboarding': typeof AuthOnboardingRouteRouteWithChildren
  '/finish-signup': typeof AuthFinishSignupRoute
  '/signin': typeof AuthSigninRoute
  '/kanban': typeof AuthenticatedKanbanRoute
  '/admin': typeof AuthenticatedContainedAdminRouteRouteWithChildren
  '/onboarding/about-you': typeof AuthOnboardingAboutYouRoute
  '/onboarding/email': typeof AuthOnboardingEmailRoute
  '/onboarding/invoices': typeof AuthOnboardingInvoicesRoute
  '/onboarding/organization': typeof AuthOnboardingOrganizationRoute
  '/signup/$': typeof AuthSignupSplatRoute
  '/dashboard': typeof AuthenticatedContainedDashboardRoute
  '/home': typeof AuthenticatedContainedHomeRoute
  '/settings': typeof AuthenticatedContainedSettingsRoute
  '/my-invoices/$invoiceId': typeof PortalMyInvoicesInvoiceIdRoute
  '/my-invoices/': typeof PortalMyInvoicesIndexRoute
  '/admin/organizations': typeof AuthenticatedContainedAdminOrganizationsRoute
  '/admin/settings': typeof AuthenticatedContainedAdminSettingsRoute
  '/admin/workflows': typeof AuthenticatedContainedAdminWorkflowsRoute
  '/customers/$customerId': typeof AuthenticatedContainedCustomersCustomerIdRouteWithChildren
  '/events/$eventId': typeof AuthenticatedContainedEventsEventIdRoute
  '/invoices/$invoiceId': typeof AuthenticatedContainedInvoicesInvoiceIdRoute
  '/reports/$reportId': typeof AuthenticatedContainedReportsReportIdRoute
  '/workflows/$workflowId': typeof AuthenticatedContainedWorkflowsWorkflowIdRoute
  '/my-invoices/pp/$installmentId': typeof PortalMyInvoicesPpInstallmentIdRoute
  '/admin/': typeof AuthenticatedContainedAdminIndexRoute
  '/customers/': typeof AuthenticatedContainedCustomersIndexRoute
  '/events/': typeof AuthenticatedContainedEventsIndexRoute
  '/invoices/': typeof AuthenticatedContainedInvoicesIndexRoute
  '/reports/': typeof AuthenticatedContainedReportsIndexRoute
  '/workflows/': typeof AuthenticatedContainedWorkflowsIndexRoute
  '/customers/$customerId/compose': typeof AuthenticatedContainedCustomersCustomerIdComposeRoute
  '/customers/$customerId/': typeof AuthenticatedContainedCustomersCustomerIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/$': typeof SplatRoute
  '/onboarding': typeof AuthOnboardingRouteRouteWithChildren
  '/finish-signup': typeof AuthFinishSignupRoute
  '/signin': typeof AuthSigninRoute
  '/kanban': typeof AuthenticatedKanbanRoute
  '/onboarding/about-you': typeof AuthOnboardingAboutYouRoute
  '/onboarding/email': typeof AuthOnboardingEmailRoute
  '/onboarding/invoices': typeof AuthOnboardingInvoicesRoute
  '/onboarding/organization': typeof AuthOnboardingOrganizationRoute
  '/signup/$': typeof AuthSignupSplatRoute
  '/dashboard': typeof AuthenticatedContainedDashboardRoute
  '/home': typeof AuthenticatedContainedHomeRoute
  '/settings': typeof AuthenticatedContainedSettingsRoute
  '/my-invoices/$invoiceId': typeof PortalMyInvoicesInvoiceIdRoute
  '/my-invoices': typeof PortalMyInvoicesIndexRoute
  '/admin/organizations': typeof AuthenticatedContainedAdminOrganizationsRoute
  '/admin/settings': typeof AuthenticatedContainedAdminSettingsRoute
  '/admin/workflows': typeof AuthenticatedContainedAdminWorkflowsRoute
  '/events/$eventId': typeof AuthenticatedContainedEventsEventIdRoute
  '/invoices/$invoiceId': typeof AuthenticatedContainedInvoicesInvoiceIdRoute
  '/reports/$reportId': typeof AuthenticatedContainedReportsReportIdRoute
  '/workflows/$workflowId': typeof AuthenticatedContainedWorkflowsWorkflowIdRoute
  '/my-invoices/pp/$installmentId': typeof PortalMyInvoicesPpInstallmentIdRoute
  '/admin': typeof AuthenticatedContainedAdminIndexRoute
  '/customers': typeof AuthenticatedContainedCustomersIndexRoute
  '/events': typeof AuthenticatedContainedEventsIndexRoute
  '/invoices': typeof AuthenticatedContainedInvoicesIndexRoute
  '/reports': typeof AuthenticatedContainedReportsIndexRoute
  '/workflows': typeof AuthenticatedContainedWorkflowsIndexRoute
  '/customers/$customerId/compose': typeof AuthenticatedContainedCustomersCustomerIdComposeRoute
  '/customers/$customerId': typeof AuthenticatedContainedCustomersCustomerIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_auth': typeof AuthRouteRouteWithChildren
  '/_authenticated': typeof AuthenticatedRouteRouteWithChildren
  '/_portal': typeof PortalRouteRouteWithChildren
  '/$': typeof SplatRoute
  '/_auth/onboarding': typeof AuthOnboardingRouteRouteWithChildren
  '/_authenticated/_contained': typeof AuthenticatedContainedRouteRouteWithChildren
  '/_auth/finish-signup': typeof AuthFinishSignupRoute
  '/_auth/signin': typeof AuthSigninRoute
  '/_authenticated/kanban': typeof AuthenticatedKanbanRoute
  '/_authenticated/_contained/admin': typeof AuthenticatedContainedAdminRouteRouteWithChildren
  '/_auth/onboarding/about-you': typeof AuthOnboardingAboutYouRoute
  '/_auth/onboarding/email': typeof AuthOnboardingEmailRoute
  '/_auth/onboarding/invoices': typeof AuthOnboardingInvoicesRoute
  '/_auth/onboarding/organization': typeof AuthOnboardingOrganizationRoute
  '/_auth/signup/$': typeof AuthSignupSplatRoute
  '/_authenticated/_contained/dashboard': typeof AuthenticatedContainedDashboardRoute
  '/_authenticated/_contained/home': typeof AuthenticatedContainedHomeRoute
  '/_authenticated/_contained/settings': typeof AuthenticatedContainedSettingsRoute
  '/_portal/my-invoices/$invoiceId': typeof PortalMyInvoicesInvoiceIdRoute
  '/_portal/my-invoices/': typeof PortalMyInvoicesIndexRoute
  '/_authenticated/_contained/admin/organizations': typeof AuthenticatedContainedAdminOrganizationsRoute
  '/_authenticated/_contained/admin/settings': typeof AuthenticatedContainedAdminSettingsRoute
  '/_authenticated/_contained/admin/workflows': typeof AuthenticatedContainedAdminWorkflowsRoute
  '/_authenticated/_contained/customers/$customerId': typeof AuthenticatedContainedCustomersCustomerIdRouteWithChildren
  '/_authenticated/_contained/events/$eventId': typeof AuthenticatedContainedEventsEventIdRoute
  '/_authenticated/_contained/invoices/$invoiceId': typeof AuthenticatedContainedInvoicesInvoiceIdRoute
  '/_authenticated/_contained/reports/$reportId': typeof AuthenticatedContainedReportsReportIdRoute
  '/_authenticated/_contained/workflows/$workflowId': typeof AuthenticatedContainedWorkflowsWorkflowIdRoute
  '/_portal/my-invoices/pp/$installmentId': typeof PortalMyInvoicesPpInstallmentIdRoute
  '/_authenticated/_contained/admin/': typeof AuthenticatedContainedAdminIndexRoute
  '/_authenticated/_contained/customers/': typeof AuthenticatedContainedCustomersIndexRoute
  '/_authenticated/_contained/events/': typeof AuthenticatedContainedEventsIndexRoute
  '/_authenticated/_contained/invoices/': typeof AuthenticatedContainedInvoicesIndexRoute
  '/_authenticated/_contained/reports/': typeof AuthenticatedContainedReportsIndexRoute
  '/_authenticated/_contained/workflows/': typeof AuthenticatedContainedWorkflowsIndexRoute
  '/_authenticated/_contained/customers/$customerId/compose': typeof AuthenticatedContainedCustomersCustomerIdComposeRoute
  '/_authenticated/_contained/customers/$customerId/': typeof AuthenticatedContainedCustomersCustomerIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/$'
    | '/onboarding'
    | '/finish-signup'
    | '/signin'
    | '/kanban'
    | '/admin'
    | '/onboarding/about-you'
    | '/onboarding/email'
    | '/onboarding/invoices'
    | '/onboarding/organization'
    | '/signup/$'
    | '/dashboard'
    | '/home'
    | '/settings'
    | '/my-invoices/$invoiceId'
    | '/my-invoices/'
    | '/admin/organizations'
    | '/admin/settings'
    | '/admin/workflows'
    | '/customers/$customerId'
    | '/events/$eventId'
    | '/invoices/$invoiceId'
    | '/reports/$reportId'
    | '/workflows/$workflowId'
    | '/my-invoices/pp/$installmentId'
    | '/admin/'
    | '/customers/'
    | '/events/'
    | '/invoices/'
    | '/reports/'
    | '/workflows/'
    | '/customers/$customerId/compose'
    | '/customers/$customerId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/$'
    | '/onboarding'
    | '/finish-signup'
    | '/signin'
    | '/kanban'
    | '/onboarding/about-you'
    | '/onboarding/email'
    | '/onboarding/invoices'
    | '/onboarding/organization'
    | '/signup/$'
    | '/dashboard'
    | '/home'
    | '/settings'
    | '/my-invoices/$invoiceId'
    | '/my-invoices'
    | '/admin/organizations'
    | '/admin/settings'
    | '/admin/workflows'
    | '/events/$eventId'
    | '/invoices/$invoiceId'
    | '/reports/$reportId'
    | '/workflows/$workflowId'
    | '/my-invoices/pp/$installmentId'
    | '/admin'
    | '/customers'
    | '/events'
    | '/invoices'
    | '/reports'
    | '/workflows'
    | '/customers/$customerId/compose'
    | '/customers/$customerId'
  id:
    | '__root__'
    | '/'
    | '/_auth'
    | '/_authenticated'
    | '/_portal'
    | '/$'
    | '/_auth/onboarding'
    | '/_authenticated/_contained'
    | '/_auth/finish-signup'
    | '/_auth/signin'
    | '/_authenticated/kanban'
    | '/_authenticated/_contained/admin'
    | '/_auth/onboarding/about-you'
    | '/_auth/onboarding/email'
    | '/_auth/onboarding/invoices'
    | '/_auth/onboarding/organization'
    | '/_auth/signup/$'
    | '/_authenticated/_contained/dashboard'
    | '/_authenticated/_contained/home'
    | '/_authenticated/_contained/settings'
    | '/_portal/my-invoices/$invoiceId'
    | '/_portal/my-invoices/'
    | '/_authenticated/_contained/admin/organizations'
    | '/_authenticated/_contained/admin/settings'
    | '/_authenticated/_contained/admin/workflows'
    | '/_authenticated/_contained/customers/$customerId'
    | '/_authenticated/_contained/events/$eventId'
    | '/_authenticated/_contained/invoices/$invoiceId'
    | '/_authenticated/_contained/reports/$reportId'
    | '/_authenticated/_contained/workflows/$workflowId'
    | '/_portal/my-invoices/pp/$installmentId'
    | '/_authenticated/_contained/admin/'
    | '/_authenticated/_contained/customers/'
    | '/_authenticated/_contained/events/'
    | '/_authenticated/_contained/invoices/'
    | '/_authenticated/_contained/reports/'
    | '/_authenticated/_contained/workflows/'
    | '/_authenticated/_contained/customers/$customerId/compose'
    | '/_authenticated/_contained/customers/$customerId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthRouteRoute: typeof AuthRouteRouteWithChildren
  AuthenticatedRouteRoute: typeof AuthenticatedRouteRouteWithChildren
  PortalRouteRoute: typeof PortalRouteRouteWithChildren
  SplatRoute: typeof SplatRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$': {
      id: '/$'
      path: '/$'
      fullPath: '/$'
      preLoaderRoute: typeof SplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_portal': {
      id: '/_portal'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof PortalRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/finish-signup': {
      id: '/_auth/finish-signup'
      path: '/finish-signup'
      fullPath: '/finish-signup'
      preLoaderRoute: typeof AuthFinishSignupRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/onboarding': {
      id: '/_auth/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof AuthOnboardingRouteRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/signin': {
      id: '/_auth/signin'
      path: '/signin'
      fullPath: '/signin'
      preLoaderRoute: typeof AuthSigninRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_authenticated/_contained': {
      id: '/_authenticated/_contained'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedContainedRouteRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/kanban': {
      id: '/_authenticated/kanban'
      path: '/kanban'
      fullPath: '/kanban'
      preLoaderRoute: typeof AuthenticatedKanbanRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_auth/onboarding/about-you': {
      id: '/_auth/onboarding/about-you'
      path: '/about-you'
      fullPath: '/onboarding/about-you'
      preLoaderRoute: typeof AuthOnboardingAboutYouRouteImport
      parentRoute: typeof AuthOnboardingRouteRoute
    }
    '/_auth/onboarding/email': {
      id: '/_auth/onboarding/email'
      path: '/email'
      fullPath: '/onboarding/email'
      preLoaderRoute: typeof AuthOnboardingEmailRouteImport
      parentRoute: typeof AuthOnboardingRouteRoute
    }
    '/_auth/onboarding/invoices': {
      id: '/_auth/onboarding/invoices'
      path: '/invoices'
      fullPath: '/onboarding/invoices'
      preLoaderRoute: typeof AuthOnboardingInvoicesRouteImport
      parentRoute: typeof AuthOnboardingRouteRoute
    }
    '/_auth/onboarding/organization': {
      id: '/_auth/onboarding/organization'
      path: '/organization'
      fullPath: '/onboarding/organization'
      preLoaderRoute: typeof AuthOnboardingOrganizationRouteImport
      parentRoute: typeof AuthOnboardingRouteRoute
    }
    '/_auth/signup/$': {
      id: '/_auth/signup/$'
      path: '/signup/$'
      fullPath: '/signup/$'
      preLoaderRoute: typeof AuthSignupSplatRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_authenticated/_contained/admin': {
      id: '/_authenticated/_contained/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AuthenticatedContainedAdminRouteRouteImport
      parentRoute: typeof AuthenticatedContainedRouteRoute
    }
    '/_authenticated/_contained/dashboard': {
      id: '/_authenticated/_contained/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthenticatedContainedDashboardRouteImport
      parentRoute: typeof AuthenticatedContainedRouteRoute
    }
    '/_authenticated/_contained/home': {
      id: '/_authenticated/_contained/home'
      path: '/home'
      fullPath: '/home'
      preLoaderRoute: typeof AuthenticatedContainedHomeRouteImport
      parentRoute: typeof AuthenticatedContainedRouteRoute
    }
    '/_authenticated/_contained/settings': {
      id: '/_authenticated/_contained/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthenticatedContainedSettingsRouteImport
      parentRoute: typeof AuthenticatedContainedRouteRoute
    }
    '/_portal/my-invoices/': {
      id: '/_portal/my-invoices/'
      path: '/my-invoices'
      fullPath: '/my-invoices/'
      preLoaderRoute: typeof PortalMyInvoicesIndexRouteImport
      parentRoute: typeof PortalRouteRoute
    }
    '/_portal/my-invoices/$invoiceId': {
      id: '/_portal/my-invoices/$invoiceId'
      path: '/my-invoices/$invoiceId'
      fullPath: '/my-invoices/$invoiceId'
      preLoaderRoute: typeof PortalMyInvoicesInvoiceIdRouteImport
      parentRoute: typeof PortalRouteRoute
    }
    '/_authenticated/_contained/admin/': {
      id: '/_authenticated/_contained/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AuthenticatedContainedAdminIndexRouteImport
      parentRoute: typeof AuthenticatedContainedAdminRouteRoute
    }
    '/_authenticated/_contained/admin/organizations': {
      id: '/_authenticated/_contained/admin/organizations'
      path: '/organizations'
      fullPath: '/admin/organizations'
      preLoaderRoute: typeof AuthenticatedContainedAdminOrganizationsRouteImport
      parentRoute: typeof AuthenticatedContainedAdminRouteRoute
    }
    '/_authenticated/_contained/admin/settings': {
      id: '/_authenticated/_contained/admin/settings'
      path: '/settings'
      fullPath: '/admin/settings'
      preLoaderRoute: typeof AuthenticatedContainedAdminSettingsRouteImport
      parentRoute: typeof AuthenticatedContainedAdminRouteRoute
    }
    '/_authenticated/_contained/admin/workflows': {
      id: '/_authenticated/_contained/admin/workflows'
      path: '/workflows'
      fullPath: '/admin/workflows'
      preLoaderRoute: typeof AuthenticatedContainedAdminWorkflowsRouteImport
      parentRoute: typeof AuthenticatedContainedAdminRouteRoute
    }
    '/_authenticated/_contained/customers/': {
      id: '/_authenticated/_contained/customers/'
      path: '/customers'
      fullPath: '/customers/'
      preLoaderRoute: typeof AuthenticatedContainedCustomersIndexRouteImport
      parentRoute: typeof AuthenticatedContainedRouteRoute
    }
    '/_authenticated/_contained/customers/$customerId': {
      id: '/_authenticated/_contained/customers/$customerId'
      path: '/customers/$customerId'
      fullPath: '/customers/$customerId'
      preLoaderRoute: typeof AuthenticatedContainedCustomersCustomerIdRouteImport
      parentRoute: typeof AuthenticatedContainedRouteRoute
    }
    '/_authenticated/_contained/events/': {
      id: '/_authenticated/_contained/events/'
      path: '/events'
      fullPath: '/events/'
      preLoaderRoute: typeof AuthenticatedContainedEventsIndexRouteImport
      parentRoute: typeof AuthenticatedContainedRouteRoute
    }
    '/_authenticated/_contained/events/$eventId': {
      id: '/_authenticated/_contained/events/$eventId'
      path: '/events/$eventId'
      fullPath: '/events/$eventId'
      preLoaderRoute: typeof AuthenticatedContainedEventsEventIdRouteImport
      parentRoute: typeof AuthenticatedContainedRouteRoute
    }
    '/_authenticated/_contained/invoices/': {
      id: '/_authenticated/_contained/invoices/'
      path: '/invoices'
      fullPath: '/invoices/'
      preLoaderRoute: typeof AuthenticatedContainedInvoicesIndexRouteImport
      parentRoute: typeof AuthenticatedContainedRouteRoute
    }
    '/_authenticated/_contained/invoices/$invoiceId': {
      id: '/_authenticated/_contained/invoices/$invoiceId'
      path: '/invoices/$invoiceId'
      fullPath: '/invoices/$invoiceId'
      preLoaderRoute: typeof AuthenticatedContainedInvoicesInvoiceIdRouteImport
      parentRoute: typeof AuthenticatedContainedRouteRoute
    }
    '/_authenticated/_contained/reports/': {
      id: '/_authenticated/_contained/reports/'
      path: '/reports'
      fullPath: '/reports/'
      preLoaderRoute: typeof AuthenticatedContainedReportsIndexRouteImport
      parentRoute: typeof AuthenticatedContainedRouteRoute
    }
    '/_authenticated/_contained/reports/$reportId': {
      id: '/_authenticated/_contained/reports/$reportId'
      path: '/reports/$reportId'
      fullPath: '/reports/$reportId'
      preLoaderRoute: typeof AuthenticatedContainedReportsReportIdRouteImport
      parentRoute: typeof AuthenticatedContainedRouteRoute
    }
    '/_authenticated/_contained/workflows/': {
      id: '/_authenticated/_contained/workflows/'
      path: '/workflows'
      fullPath: '/workflows/'
      preLoaderRoute: typeof AuthenticatedContainedWorkflowsIndexRouteImport
      parentRoute: typeof AuthenticatedContainedRouteRoute
    }
    '/_authenticated/_contained/workflows/$workflowId': {
      id: '/_authenticated/_contained/workflows/$workflowId'
      path: '/workflows/$workflowId'
      fullPath: '/workflows/$workflowId'
      preLoaderRoute: typeof AuthenticatedContainedWorkflowsWorkflowIdRouteImport
      parentRoute: typeof AuthenticatedContainedRouteRoute
    }
    '/_portal/my-invoices/pp/$installmentId': {
      id: '/_portal/my-invoices/pp/$installmentId'
      path: '/my-invoices/pp/$installmentId'
      fullPath: '/my-invoices/pp/$installmentId'
      preLoaderRoute: typeof PortalMyInvoicesPpInstallmentIdRouteImport
      parentRoute: typeof PortalRouteRoute
    }
    '/_authenticated/_contained/customers/$customerId/': {
      id: '/_authenticated/_contained/customers/$customerId/'
      path: '/'
      fullPath: '/customers/$customerId/'
      preLoaderRoute: typeof AuthenticatedContainedCustomersCustomerIdIndexRouteImport
      parentRoute: typeof AuthenticatedContainedCustomersCustomerIdRoute
    }
    '/_authenticated/_contained/customers/$customerId/compose': {
      id: '/_authenticated/_contained/customers/$customerId/compose'
      path: '/compose'
      fullPath: '/customers/$customerId/compose'
      preLoaderRoute: typeof AuthenticatedContainedCustomersCustomerIdComposeRouteImport
      parentRoute: typeof AuthenticatedContainedCustomersCustomerIdRoute
    }
  }
}

interface AuthOnboardingRouteRouteChildren {
  AuthOnboardingAboutYouRoute: typeof AuthOnboardingAboutYouRoute
  AuthOnboardingEmailRoute: typeof AuthOnboardingEmailRoute
  AuthOnboardingInvoicesRoute: typeof AuthOnboardingInvoicesRoute
  AuthOnboardingOrganizationRoute: typeof AuthOnboardingOrganizationRoute
}

const AuthOnboardingRouteRouteChildren: AuthOnboardingRouteRouteChildren = {
  AuthOnboardingAboutYouRoute: AuthOnboardingAboutYouRoute,
  AuthOnboardingEmailRoute: AuthOnboardingEmailRoute,
  AuthOnboardingInvoicesRoute: AuthOnboardingInvoicesRoute,
  AuthOnboardingOrganizationRoute: AuthOnboardingOrganizationRoute,
}

const AuthOnboardingRouteRouteWithChildren =
  AuthOnboardingRouteRoute._addFileChildren(AuthOnboardingRouteRouteChildren)

interface AuthRouteRouteChildren {
  AuthOnboardingRouteRoute: typeof AuthOnboardingRouteRouteWithChildren
  AuthFinishSignupRoute: typeof AuthFinishSignupRoute
  AuthSigninRoute: typeof AuthSigninRoute
  AuthSignupSplatRoute: typeof AuthSignupSplatRoute
}

const AuthRouteRouteChildren: AuthRouteRouteChildren = {
  AuthOnboardingRouteRoute: AuthOnboardingRouteRouteWithChildren,
  AuthFinishSignupRoute: AuthFinishSignupRoute,
  AuthSigninRoute: AuthSigninRoute,
  AuthSignupSplatRoute: AuthSignupSplatRoute,
}

const AuthRouteRouteWithChildren = AuthRouteRoute._addFileChildren(
  AuthRouteRouteChildren,
)

interface AuthenticatedContainedAdminRouteRouteChildren {
  AuthenticatedContainedAdminOrganizationsRoute: typeof AuthenticatedContainedAdminOrganizationsRoute
  AuthenticatedContainedAdminSettingsRoute: typeof AuthenticatedContainedAdminSettingsRoute
  AuthenticatedContainedAdminWorkflowsRoute: typeof AuthenticatedContainedAdminWorkflowsRoute
  AuthenticatedContainedAdminIndexRoute: typeof AuthenticatedContainedAdminIndexRoute
}

const AuthenticatedContainedAdminRouteRouteChildren: AuthenticatedContainedAdminRouteRouteChildren =
  {
    AuthenticatedContainedAdminOrganizationsRoute:
      AuthenticatedContainedAdminOrganizationsRoute,
    AuthenticatedContainedAdminSettingsRoute:
      AuthenticatedContainedAdminSettingsRoute,
    AuthenticatedContainedAdminWorkflowsRoute:
      AuthenticatedContainedAdminWorkflowsRoute,
    AuthenticatedContainedAdminIndexRoute:
      AuthenticatedContainedAdminIndexRoute,
  }

const AuthenticatedContainedAdminRouteRouteWithChildren =
  AuthenticatedContainedAdminRouteRoute._addFileChildren(
    AuthenticatedContainedAdminRouteRouteChildren,
  )

interface AuthenticatedContainedCustomersCustomerIdRouteChildren {
  AuthenticatedContainedCustomersCustomerIdComposeRoute: typeof AuthenticatedContainedCustomersCustomerIdComposeRoute
  AuthenticatedContainedCustomersCustomerIdIndexRoute: typeof AuthenticatedContainedCustomersCustomerIdIndexRoute
}

const AuthenticatedContainedCustomersCustomerIdRouteChildren: AuthenticatedContainedCustomersCustomerIdRouteChildren =
  {
    AuthenticatedContainedCustomersCustomerIdComposeRoute:
      AuthenticatedContainedCustomersCustomerIdComposeRoute,
    AuthenticatedContainedCustomersCustomerIdIndexRoute:
      AuthenticatedContainedCustomersCustomerIdIndexRoute,
  }

const AuthenticatedContainedCustomersCustomerIdRouteWithChildren =
  AuthenticatedContainedCustomersCustomerIdRoute._addFileChildren(
    AuthenticatedContainedCustomersCustomerIdRouteChildren,
  )

interface AuthenticatedContainedRouteRouteChildren {
  AuthenticatedContainedAdminRouteRoute: typeof AuthenticatedContainedAdminRouteRouteWithChildren
  AuthenticatedContainedDashboardRoute: typeof AuthenticatedContainedDashboardRoute
  AuthenticatedContainedHomeRoute: typeof AuthenticatedContainedHomeRoute
  AuthenticatedContainedSettingsRoute: typeof AuthenticatedContainedSettingsRoute
  AuthenticatedContainedCustomersCustomerIdRoute: typeof AuthenticatedContainedCustomersCustomerIdRouteWithChildren
  AuthenticatedContainedEventsEventIdRoute: typeof AuthenticatedContainedEventsEventIdRoute
  AuthenticatedContainedInvoicesInvoiceIdRoute: typeof AuthenticatedContainedInvoicesInvoiceIdRoute
  AuthenticatedContainedReportsReportIdRoute: typeof AuthenticatedContainedReportsReportIdRoute
  AuthenticatedContainedWorkflowsWorkflowIdRoute: typeof AuthenticatedContainedWorkflowsWorkflowIdRoute
  AuthenticatedContainedCustomersIndexRoute: typeof AuthenticatedContainedCustomersIndexRoute
  AuthenticatedContainedEventsIndexRoute: typeof AuthenticatedContainedEventsIndexRoute
  AuthenticatedContainedInvoicesIndexRoute: typeof AuthenticatedContainedInvoicesIndexRoute
  AuthenticatedContainedReportsIndexRoute: typeof AuthenticatedContainedReportsIndexRoute
  AuthenticatedContainedWorkflowsIndexRoute: typeof AuthenticatedContainedWorkflowsIndexRoute
}

const AuthenticatedContainedRouteRouteChildren: AuthenticatedContainedRouteRouteChildren =
  {
    AuthenticatedContainedAdminRouteRoute:
      AuthenticatedContainedAdminRouteRouteWithChildren,
    AuthenticatedContainedDashboardRoute: AuthenticatedContainedDashboardRoute,
    AuthenticatedContainedHomeRoute: AuthenticatedContainedHomeRoute,
    AuthenticatedContainedSettingsRoute: AuthenticatedContainedSettingsRoute,
    AuthenticatedContainedCustomersCustomerIdRoute:
      AuthenticatedContainedCustomersCustomerIdRouteWithChildren,
    AuthenticatedContainedEventsEventIdRoute:
      AuthenticatedContainedEventsEventIdRoute,
    AuthenticatedContainedInvoicesInvoiceIdRoute:
      AuthenticatedContainedInvoicesInvoiceIdRoute,
    AuthenticatedContainedReportsReportIdRoute:
      AuthenticatedContainedReportsReportIdRoute,
    AuthenticatedContainedWorkflowsWorkflowIdRoute:
      AuthenticatedContainedWorkflowsWorkflowIdRoute,
    AuthenticatedContainedCustomersIndexRoute:
      AuthenticatedContainedCustomersIndexRoute,
    AuthenticatedContainedEventsIndexRoute:
      AuthenticatedContainedEventsIndexRoute,
    AuthenticatedContainedInvoicesIndexRoute:
      AuthenticatedContainedInvoicesIndexRoute,
    AuthenticatedContainedReportsIndexRoute:
      AuthenticatedContainedReportsIndexRoute,
    AuthenticatedContainedWorkflowsIndexRoute:
      AuthenticatedContainedWorkflowsIndexRoute,
  }

const AuthenticatedContainedRouteRouteWithChildren =
  AuthenticatedContainedRouteRoute._addFileChildren(
    AuthenticatedContainedRouteRouteChildren,
  )

interface AuthenticatedRouteRouteChildren {
  AuthenticatedContainedRouteRoute: typeof AuthenticatedContainedRouteRouteWithChildren
  AuthenticatedKanbanRoute: typeof AuthenticatedKanbanRoute
}

const AuthenticatedRouteRouteChildren: AuthenticatedRouteRouteChildren = {
  AuthenticatedContainedRouteRoute:
    AuthenticatedContainedRouteRouteWithChildren,
  AuthenticatedKanbanRoute: AuthenticatedKanbanRoute,
}

const AuthenticatedRouteRouteWithChildren =
  AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

interface PortalRouteRouteChildren {
  PortalMyInvoicesInvoiceIdRoute: typeof PortalMyInvoicesInvoiceIdRoute
  PortalMyInvoicesIndexRoute: typeof PortalMyInvoicesIndexRoute
  PortalMyInvoicesPpInstallmentIdRoute: typeof PortalMyInvoicesPpInstallmentIdRoute
}

const PortalRouteRouteChildren: PortalRouteRouteChildren = {
  PortalMyInvoicesInvoiceIdRoute: PortalMyInvoicesInvoiceIdRoute,
  PortalMyInvoicesIndexRoute: PortalMyInvoicesIndexRoute,
  PortalMyInvoicesPpInstallmentIdRoute: PortalMyInvoicesPpInstallmentIdRoute,
}

const PortalRouteRouteWithChildren = PortalRouteRoute._addFileChildren(
  PortalRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthRouteRoute: AuthRouteRouteWithChildren,
  AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,
  PortalRouteRoute: PortalRouteRouteWithChildren,
  SplatRoute: SplatRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
